export default function ellipsis(str: string, limit: number): string {
    return str.length > limit ? `${str.substring(0, limit)}…` : str;
}
